import { ROLES } from "@ea/shared_types/next/ea.enums";

// this file exists because the following routes are also used on the server, e.g. in middleware
// the configuration in clientOnlyRoutes uses functions available only on the client so we can't define them there, as it leads to errors

/**
 * The default redirect path after logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT = "/";

export const AUTH_PAGE = "/auth";
export const LOGIN_PAGE = "/auth/login";
export const LOGOUT_PAGE = "/auth/logout";
export const SETUP_PAGE = "/setup";

/**
 * An array of routes that are accessible to the public
 * These routes do not require authentication
 * @type {string[]}
 */

export const publicRoutes = [AUTH_PAGE, LOGIN_PAGE, "/extension", SETUP_PAGE];

/**
 * An array of routes that are used for authentication
 * These routes will redirect logged in users to DEFAULT_LOGIN_REDIRECT
 * @type {string[]}
 */
export const authRoutes = [LOGIN_PAGE];

/**
 * Routes groups used in permissions control
 * @type {Object}
 */
export const ROUTES_GROUPS = {
  account: "/account/*",
  chat: "/chat/*",
  scripts: "/scripts/*",
  history: "/history/*",
  scheduler: "/scheduler/*",
  settings: "/settings/*",
  projects: "/projects/*",
  reports: "/reports/*",
  documentation_tree: "/documentation_tree/*",
  documentation: "/documentation/*",
  runner: "/runner/*",
} as const satisfies Record<string, string>;

/**
 * Routes that allowed or disallowed selected roles to enter selected route
 */
export const allowedRoleRoutes = {
  [ROUTES_GROUPS.history]: {
    allowedRoles: [ROLES.logs],
    disallowedRoles: [ROLES.documentationReader],
  },
  [ROUTES_GROUPS.account]: {
    allowedRoles: [],
    disallowedRoles: [],
  },
  [ROUTES_GROUPS.chat]: {
    allowedRoles: [],
    disallowedRoles: [],
  },
  [ROUTES_GROUPS.scheduler]: {
    allowedRoles: [ROLES.scheduler],
    disallowedRoles: [ROLES.documentationReader],
  },
  [ROUTES_GROUPS.settings]: {
    allowedRoles: [ROLES.settings],
    disallowedRoles: [ROLES.documentationReader],
  },
  [ROUTES_GROUPS.projects]: {
    allowedRoles: [ROLES.projects],
    disallowedRoles: [],
  },
  [ROUTES_GROUPS.reports]: {
    allowedRoles: [ROLES.reports],
    disallowedRoles: [],
  },
  [ROUTES_GROUPS.runner]: {
    allowedRoles: [],
    disallowedRoles: [],
  },
  [ROUTES_GROUPS.scripts]: {
    allowedRoles: [],
    disallowedRoles: [],
  },
};
